// ABOUTME: Route for /skills/new — fullscreen editor for creating a skill.
import { SkillEditorPage } from "@/components/skills/SkillEditorPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/skills/new")({
  component: () => <SkillEditorPage mode="create" />,
});
